import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductIdv14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_179)'>
      <path
        d='M1.75 1.75H4V0.25H1.42857C0.777664 0.25 0.25 0.777664 0.25 1.42857V4H1.75V1.75Z'
        fill='currentColor'
      />
      <path
        d='M12.25 1.75H10V0.25H12.5714C13.2223 0.25 13.75 0.777666 13.75 1.42857V4H12.25V1.75Z'
        fill='currentColor'
      />
      <path
        d='M1.75 12.25V10H0.25V12.5714C0.25 13.2223 0.777666 13.75 1.42857 13.75H4V12.25H1.75Z'
        fill='currentColor'
      />
      <path
        d='M12.25 12.25V10H13.75V12.5714C13.75 13.2223 13.2223 13.75 12.5714 13.75H10V12.25H12.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 5.5C4.75 4.25736 5.75736 3.25 7 3.25C8.24264 3.25 9.25 4.25736 9.25 5.5C9.25 6.22197 8.90996 6.86452 8.3813 7.27622C9.71962 7.46186 10.75 8.6106 10.75 10H9.25C9.25 9.30964 8.69036 8.75 8 8.75H6C5.30964 8.75 4.75 9.30964 4.75 10H3.25C3.25 8.6106 4.28038 7.46186 5.6187 7.27622C5.09004 6.86452 4.75 6.22197 4.75 5.5ZM7 4.75C6.58579 4.75 6.25 5.08579 6.25 5.5C6.25 5.91421 6.58579 6.25 7 6.25C7.41421 6.25 7.75 5.91421 7.75 5.5C7.75 5.08579 7.41421 4.75 7 4.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_179'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductIdv14.displayName = 'ProductIdv14';
export default ProductIdv14;
